import { Routes } from '@angular/router';
import { DataManagementAdminComponent } from './components/data-management-admin/data-management-admin.component';

export const DATA_MANAGEMENT_ROUTES: Routes = [{
	path: 'Data', component: DataManagementAdminComponent
}];
